<template>
  <div>
    <v-container>
      <v-layout
        v-if="personAuthenticated"
        justify-center
        column>
        <v-flex class="text-xs-center pa-3">
          <h3>Select Your Vehicle</h3>
        </v-flex>
        <v-flex>
          <v-select
            v-model="vehicleID"
            :items="vehicleItems"
            label="Vehicle"
            item-text="name"
            item-value="id"
            prepend-icon="fa-car"
          />
        </v-flex>
        <v-flex class="text-xs-center pa-3">
          <h3>OR</h3>
        </v-flex>
        <v-flex>
          <v-expansion-panel v-model="createFormOpen">
            <v-expansion-panel-content>
              <div
                slot="header"
                class="text-xs-center pa-3"
              >
                <h3>Register a New Vehicle</h3>
              </div>
              <v-card>
                <v-card-text>
                  <VehicleForm @close="createFormOpen = null"/>
                </v-card-text>
              </v-card>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-flex>
      </v-layout>
    </v-container>
    <v-alert
      :value="true"
      dismissible
      type="warning"
    >
      <span
        v-html="settings.textParking"
      />
    </v-alert>
  </div>
</template>
<script>
// import modules
import VehicleForm from '@/components/reserve/forms/Vehicle'
// import vuex mapping
import { mapFields } from 'vuex-map-fields'
import { mapActions, mapGetters } from 'vuex'
// our new component
export default {
  components: {
    VehicleForm
  },
  data () {
    return {
      createFormOpen: null
    }
  },
  computed: {
    ...mapFields({
      vehicleID: 'facilities.searchCriteria.vehicleID'
    }),
    ...mapGetters({
      personAuthenticated: 'person/authenticated',
      vehicles: 'vehicles/vehicles'
    }),
    vehicleItems () {
      let vehicles = []
      for (let vehicle of this.vehicles) {
        vehicles.push({
          name: `${vehicle.vehicleMake} ${vehicle.vehicleModel}: ${vehicle.vehicleLicensePlate}`,
          id: vehicle.vehicleID
        })
      }
      return vehicles
    }
  },
  mounted () {
    if (this.personAuthenticated) {
      this.getVehicles()
    }
  },
  methods: {
    ...mapActions({
      getVehicles: 'vehicles/getVehicles'
    })
  }
}
</script>
